// extracted by mini-css-extract-plugin
module.exports = {"blog_article__related_post":"relatedpost_blog_article__related_post__HAIec","blog_article__related_post_article":"relatedpost_blog_article__related_post_article__yBjTx"};